<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12FgbrM/tc-custom/9781504097086.jpg?1725420213345" alt="This image is the cover for the book Man Next Door"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Man Next Door
      </h1>
      <p class="bookDescription body article font2">
        <b>Set during WWII and featuring a female sleuth, “a good spy story with overtones of romance; tense situations and excellent characterization” (<i>The New York Times</i>).</b><br/><br/>Maida Lovell takes her job as secretary to the US War Department head, Steve Blake, seriously. So when a routine assignment to pick up some notes at his family’s home has her stumbling upon a body, and Steve sure to be the chief suspect, Maida agrees to a coverup to protect her boss. <br/><br/>But the tables quickly turn and suddenly Maida is at the mercy of an enemy spy intent on blackmailing her into uncovering national secrets. Now, Maida must do all she can to save herself—and her country—from disaster.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mignon G. Eberhart
      </h2>
      
      <p class="authorDescription body article">Mignon G. Eberhart (1899–1996) wrote dozens of mystery novels over nearly sixty years. Born in Lincoln, Nebraska, she began writing in high school, swapping English essays with her fellow students in exchange for math homework. She attended Nebraska Wesleyan University, and in the 1920s began writing fiction in her spare time, publishing her first novel, <I>The Patient in Room 18</I>, in 1929. With the follow-up, <I>While the Patient Slept</I> (1931), she won a $5,000 Scotland Yard Prize, and by the end of the 1930s she was one of the most popular female mystery writers on the planet.<br/><br/>Before Agatha Christie ever published a Miss Marple novel, Eberhart wrote romantic crime fiction with female leads. Eight of her books, including <I>While the Patient Slept</I> and <I>Hasty Wedding </I>(1938), were adapted for film. Elected a Mystery Writers of America Grand Master in 1971, Eberhart continued publishing roughly a book a year until the 1980s. Her final novel, <I>Three Days for Emeralds</I>, was published in 1988.<br/><br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40865323